export const POST_GRADUATIONS_LIST = [
  {
    id: 1,
    title: 'Residência em Segurança Cibernética 2022',
    slug: 'rsc-2022',
    status: 'encerrado'
  },
  {
    id: 2,
    title: 'Residência em Segurança Cibernética 2026',
    slug: 'rsc-2026',
    status: 'encerrado'
  }
]
